import { render, staticRenderFns } from "./chart-wrapper.vue?vue&type=template&id=a1a9eece&scoped=true&"
import script from "./chart-wrapper.vue?vue&type=script&lang=js&"
export * from "./chart-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a9eece",
  null
  
)

export default component.exports